import { createSlice } from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";

export interface GalleryState {
  imagesList: any;
  allImageTypes: any
  isApiOnGoing: false;
}

const initialState: GalleryState = {
  imagesList: [],
  allImageTypes: {},
  isApiOnGoing: false
}

export const gallerySlice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    getImagesByType: (state, actions) => { },
    deleteImage: (state, actions) => { },
    updateImageData: (state, actions) => { },
    getAllImageTypes: (state) => { },
    bulkUploadImages: (state, actions) => {},
    saveImageTypes: (state, actions) => {
      const imageTypesMap = actions.payload.reduce((obj: any, item: string) => {
        obj[item.toLocaleLowerCase()] = {name: item};
        return obj;
      }, {});
      state.allImageTypes = imageTypesMap;
    }
  }
})

export const {
  getImagesByType,
  deleteImage,
  updateImageData,
  getAllImageTypes,
  saveImageTypes,
  bulkUploadImages
} = gallerySlice.actions;
export default gallerySlice.reducer;